// @ts-strict-ignore
import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit } from '@angular/core';
import { DeviceSize } from '../../../../model/device-size';
import { DeviceService } from '../../../../services/device-service/device.service';

@Component({
    selector: 'app-device-specific',
    templateUrl: './device-specific.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DeviceSpecificComponent implements OnInit {
  @HostListener('window:resize', ['$event']) onResize() {
    this._updateRenderStatus();
  }

  @Input() renderAbove?: DeviceSize;
  @Input() renderBelow?: DeviceSize;

  deviceSizes: DeviceSize[] = [];
  shouldRender: boolean;

  constructor(private _deviceService: DeviceService) {
    this.deviceSizes = Object.values(DeviceSize);
  }

  ngOnInit(): void {
    this._updateRenderStatus();
  }

  private _updateRenderStatus() {
    const deviceSize = this._deviceService.deviceSize;
    const aboveIndex = this.deviceSizes.indexOf(this.renderAbove) ?? null;
    const belowIndex = this.deviceSizes.indexOf(this.renderBelow) ?? null;

    let breakpoints;
    if (this.renderAbove && this.renderBelow) {
      breakpoints = this.deviceSizes.slice(aboveIndex, belowIndex);
    } else if (this.renderAbove) {
      breakpoints = this.deviceSizes.slice(aboveIndex);
    } else if (this.renderBelow) {
      breakpoints = this.deviceSizes.slice(0, belowIndex);
    }

    this.shouldRender = breakpoints?.includes(deviceSize);
  }
}
